<section class="new__tabs">
  <div class="new__tabs__section container py-lg-2">
    <ng-container *ngFor="let tab of tabs(); let i = index">
      <a
        (click)="handleTabClick($event, tab, i)"
        [attr.href]="tab.url"
        [attr.target]="tab.openExternally ? '_blank' : null"
        [class.active]="isActiveRoute(i)"
        [class.has-badge]="!!tab.badgeText"
        rel="noopener noreferer"
      >
        <ng-container
          [ngTemplateOutlet]="tabContent"
          [ngTemplateOutletContext]="{ tab }"
        ></ng-container>
      </a>
    </ng-container>
  </div>
</section>

<ng-template #tabContent let-tab="tab">
  <i [className]="'custom-icon ' + tab.icon"></i>
  <span class="text-wrap lh-1">{{ tab.label }}</span>
  <span
    *ngIf="tab.badgeText"
    class="badge xx-small fw-semibold rounded-pill bg-primary text-uppercase"
  >
    {{ tab.badgeText }}
  </span>
</ng-template>
